module.exports = __webpack_public_path__ + "static/icon_milano_nordest_grigio-f613d4678615f11e8fe53dddeb2c5be2.svg";